import { useQuery } from '@apollo/client';
import {
  QUERY_FETCH_LATEST_UPDATES,
  type FetchLatestUpdatesQuery,
  type FetchLatestUpdatesQueryVariables,
} from '@edwin-group/people-graphql';
import { useMemo } from 'react';

export type LatestUpdateItem = NonNullable<FetchLatestUpdatesQuery['fetchLatestUpdates']>[number];

export const useLatestUpdates = () => {
  const { data, loading, error } = useQuery<FetchLatestUpdatesQuery, FetchLatestUpdatesQueryVariables>(
    QUERY_FETCH_LATEST_UPDATES,
    {
      fetchPolicy: 'cache-first',
      errorPolicy: 'all',
      context: {
        skipAuthRedirect: true,
      },
    },
  );

  const updates = useMemo(() => {
    if (error && !data?.fetchLatestUpdates) {
      return [];
    }

    return (data?.fetchLatestUpdates ?? []).filter(Boolean) as LatestUpdateItem[];
  }, [data, error]);

  return {
    updates,
    loading,
    error,
  };
};
